// extracted by mini-css-extract-plugin
export default {"root":"D5Feux","checkbox":"WTKV7N","checkboxOuter":"H3EJmg","checked":"mEyS8a"};